import { Component, OnInit } from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {ViewEncapsulation} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import {Router} from '@angular/router';
import { Item, ITEMS } from '../rating-data';
import { AmazingTimePickerService } from 'amazing-time-picker';
@Component({
  selector: 'app-sample',
  templateUrl: './sample.component.html',
  styleUrls: ['./sample.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SampleComponent implements OnInit {
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  private postURL='https://api.on-track.in/api/getBookingByQuery';
public data:any=[];
radioSel: any;
radioSelected: string;
radioSelectedString: string;
itemsList: Item[] = ITEMS;
showText:boolean=true;
  public buttonText: any = 'Login';

  //public buttonName: any = 'Logout';
  toggleLogin() {
    this.showText = !this.showText;

    // CHANGE THE NAME OF THE BUTTON.
    if (this.showText)
      this.buttonText = "Login";
    else
      this.buttonText = "Logout";
  }
  // btnTextShow: string ='Login';
  // btnTextHide: string ='Sign Up'
  
  // btnText:string =this.btnTextHide;

  // toggle:boolean = true;
  // toggleText:string ='Sign Up';

  public show:boolean = true;
  public buttonName:any = 'Sign Up';

  divs: Array<any> = ["Menu1", "Menu2"];
 visibleDivId:number = null;
 
  // toggleC()
  // {
   
  //   this.toggle = !this.toggle
  //   this.toggleText = this.toggle ? 'Sign Up!' : 'Login';
  // }

abc:number=90;

helloWorld() {
  //this.saveInLocal('m1','dhgsadhgas');
  //this.saveInLocal('m1','dhgsadhgas');
  this.logoutUser();
  console.log("hellow orls");
  let custId = this.getFromLocal('customerid');
  console.log(this.getFromLocal('m1'));
  if (custId == null){
    console.log("no user logged in");
  }
  //this.router.navigate(['/login']);
  console.log(custId);
  return this.abc;
}

logoutUser(){
  this.saveInLocal('customerid',null);
  this.saveInLocal('m1',null);
}

// data: Observable<Array<any>>;
// constructor(private apiService: ApiService) {
//   this.data = apiService.get('customer');
//   console.log(this.data);

// }

constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private router: Router,private httpClient:HttpClient,
private atp: AmazingTimePickerService) {
  this.itemsList = ITEMS;
  this.radioSelected = "Okay";
  this.getSelecteditem();
}
getSelecteditem() {
  this.radioSel = ITEMS.find(Item => Item.value === this.radioSelected);
  this.radioSelectedString = JSON.stringify(this.radioSel);
  //console.log(this.radioSel.id);
}

onItemChange(item) {
  this.getSelecteditem();

}
getCompleted()
{
  this.httpClient.post(this.postURL, 0)
    .subscribe(
      (data:any) => {
        console.log("data is:" +data);
      }
    )
}

saveInLocal(key, val): void {
  //console.log('recieved= key:' + key + 'value:' + val);
  this.storage.set(key, val);
  this.data[key]= this.storage.get(key);
}

getFromLocal(key): void {
  //console.log('recieved= key:' + key);
  return this.data[key]= this.storage.get(key);
  //console.log(this.data);
  //return this.data;
}

  ngOnInit() {
    //this.loadAllUsers();
    //this.helloWorld();
  }

 

  toggleH() {
    this.show = !this.show;

    // CHANGE THE NAME OF THE BUTTON.
    if(this.show)  
      this.buttonName = "Sign Up";
    else
      this.buttonName = "Login";
  }

   toggleVisibility(divId) {
    if(this.visibleDivId === divId) {
      //visibleDivId = null;
    } else {
      this.visibleDivId = divId;
    }
    this.hideNonVisibleDivs();
  }
hideNonVisibleDivs() {
  
   let i, divId, div;
    for(i = 0; i < this.divs.length; i++) {
      divId = this.divs[i];
      div = document.getElementById(divId);
      if(this.visibleDivId === divId) {
        div.style.display = "block";
      } else {
        div.style.display = "none";
      }
    }
  }

 
  


// vaaaaaa:int;
// vaaaaaa = 90;

// function convetTodays(noOfdAYS:int) {
//   return 100 - (noOfdAYS*100)/30;
// }
// console.log(Math.round(convetTodays(15));
// //console.log(100- convetTodays(1));
// this.abc=Math.round(convetTodays(15);
// console.log(this.abc);


public myDate = new Date(); 
  minDate = this.myDate; 
  maxDate = new Date( 
    this.myDate.getFullYear(),
    this.myDate.getMonth() ,
    this.myDate.getDate()+ 4);
  time = this.myDate.getTime();  
  myFilter = (d: Date): boolean => {
    const day = d.getDay() ;
    return day !== 0;
  }

getTimeSlot(dateSlot) {
  let dateToSearch = "";
  if ((typeof dateSlot === 'string') && (dateSlot.indexOf('/') > -1)) {
    const str = dateSlot.split('/');
    const year = Number(str[2]);
    const date = Number(str[1]);
    const month = Number(str[0]);
    dateToSearch = year + "-" + month + "-" + date;
  }

  if ((dateToSearch != null) || (dateToSearch != "")) {
    let dateData = { date: dateToSearch }
    // if (this.debugData) {
      console.log("get time slot function data");
      console.log(dateData);
    // }
  }  
}

 }



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/sample/sample.component.ts